import { FC } from 'react';
import { Control, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import Divider from '@mui/material/Divider';
import GeneralInformation from './GeneralInformation';
import FundOverviewDatapoints from './FundOverviewDatapoints';
import PortfolioUpdateFile from './PortfolioUpdateFile';
import NotificationPreferences from './NotificationPreferences';
import RecipientList from './RecipientList';
import { PeriodEndReportFormValues } from './schema';
import { PeriodEndReport } from './types';

type Props = {
  control: Control<PeriodEndReportFormValues>;
  setValue: UseFormSetValue<PeriodEndReportFormValues>;
  getValues: UseFormGetValues<PeriodEndReportFormValues>;
  readOnly: boolean;
  periodEndReport: PeriodEndReport;
};

const AddEditPeriodEndReportForm: FC<Props> = ({
  control,
  setValue,
  getValues,
  readOnly,
  periodEndReport,
}) => {
  const {
    id,
    vehicleId,
    portfolioUpdateFile,
    baseCurrency,
    periodStart,
    periodEnd,
  } = periodEndReport;

  return (
    <>
      <GeneralInformation
        control={control}
        readOnly={readOnly}
        getValues={getValues}
        periodStart={periodStart}
        periodEnd={periodEnd}
      />
      <Divider />
      <FundOverviewDatapoints
        control={control}
        readOnly={readOnly}
        getValues={getValues}
      />
      {!readOnly || portfolioUpdateFile ? (
        <>
          <Divider />
          <PortfolioUpdateFile control={control} readOnly={readOnly} />
        </>
      ) : null}
      {!readOnly ? (
        <>
          <Divider />
          <NotificationPreferences control={control} setValue={setValue} />
        </>
      ) : null}
      {readOnly && id ? (
        <>
          <Divider />
          <RecipientList
            control={control}
            vehicleId={vehicleId}
            id={id}
            baseCurrency={baseCurrency}
          />
        </>
      ) : null}
    </>
  );
};

export default AddEditPeriodEndReportForm;
